import React, { useEffect, useRef, useState } from "react";
import {
  Badge,
  Col,
  Container,
  Dropdown,
  DropdownButton,
  Form,
  Image,
  Nav,
  Overlay,
  Row,
  Tab,
  Table,
  Tooltip,
} from "react-bootstrap";
import viewaction from "../../assets/images/viewaction.svg";
import profilepageman from "../../assets/images/dummy-profile-pic.jpg";
import { useDispatch, useSelector } from "react-redux";
import {
  CaseGetByDetail,
  CaseGetList,
  CaseUpdateStatus,
} from "../../services/ReduxTookit/Slice/CaseRedux";
import Loader, { LoaderType } from "../../component/common-component/Loader";
import Nodata from "../../component/common-component/Nodata";
import CaseFilterPopup from "./PopUpModels/CaseFilterPopup";
import filtericon from "../../assets/images/filter.svg";
import profilepic from "../../assets/images/dummy-profile-pic.jpg";
import { commonservices } from "../../services/CommonServices";
import { ProjectTermGetList } from "../../services/ReduxTookit/Slice/ProjectTermRedux";
import SupportCaseContactModel from "./PopUpModels/SupportCaseContactModel";
import dropdownafter from "../../assets/images/dropdownafter.svg";
import inProcessStatus from "../../assets/images/inProcessStatus.svg";
import { useLocation, useNavigate } from "react-router-dom";
import SVGRef from "../../assets/images/pdfref.svg";
import noDataFound from "../../assets/images/nodatafound.png";
import dummyBanner from "../../assets/images/dummyBanner.png";

const CaseHistoryManagementModel = ({ dataHistoryId, setDataHistoryId }) => {
  let Userdata = useSelector((state) => state?.userinfo?.UserInfo);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const targetFilter = useRef(null);
  const contactRef = useRef();
  const overlayCont_Ref = useRef(null);
  const params = useLocation();

  const searchParams = new URLSearchParams(params?.search?.split("?")[1]);
  const ViewParam = searchParams.get("r");
  const [casesList, setCasesList] = useState([]);
  const [selectedFile, setSelectedFile] = useState({
    fileNo: 0,
    path: "",
    data: "",
  });
  const [showCaseDetails, setShowCaseDetails] = useState(false);
  const [caseId, setCaseId] = useState(null);
  const [loading, setLoading] = useState([]);
  const [showSchedularPopup, setShowSchedularPopup] = useState(false);
  const [caseStatus, setCaseStatus] = useState("");
  useEffect(() => {
    setCaseId(dataHistoryId);
  }, [dataHistoryId]);
  useEffect(() => {
    if (ViewParam) {
      setCaseId(null);
    }
  }, [ViewParam]);
  const [curr_CaseData, setCurr_CaseData] = useState({
    data: null,
    comments: [],
    files: [],
  });
  const [ProjectTermList, setProjectTermList] = useState({
    CaseType: [],
  });
  const [filters, setFilters] = useState({
    status: "",
    priority: "",
    caseType: "",
  });
  const [sort, setSort] = useState({
    date: "",
    status: "",
    priority: "",
    caseType: "",
  });
  const [showContact, setShowContact] = useState(false);

  const FetchCaseGetList = (e) => {
    let body = {
      casetype_term: filters.caseType ? filters.caseType : "",
      casestatus_term: "Closed",
      priority_term: filters.priority ? filters.priority : "",
      sortfield: sortStatePayload?.field ? sortStatePayload?.field : "",
      sortorder: sortStatePayload?.direction ? sortStatePayload?.direction : "",
    };

    setLoading(true);
    dispatch(CaseGetList(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        setCasesList(response?.payload?.data?.data);

        setLoading(false);
      }
      if (!response?.payload?.isValidate) {
        setCasesList([]);
        setLoading(false);
      }
    });
  };

  const FetchAll_CaseDetailById = async (CaseId) => {
    let body = {
      id: CaseId,
    };
    setLoading(true);
    dispatch(CaseGetByDetail(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        let CaseData = response?.payload?.data?.data?.dataList1[0]; // Case Details Data
        let CaseComentsData = response?.payload?.data?.data?.dataList2; // Coments Data
        let CaseFilesData = response?.payload?.data?.data?.dataList3; // Files Data
        // let CaseData4 = response?.payload?.data?.data?.dataList4;
        setCaseStatus(CaseData?.casestatus_term);
        setSelectedFile({
          fileNo: CaseFilesData[0]?.caseattachmentid,
          path: CaseFilesData[0]?.path,
          data: CaseFilesData[0],
        });
        setCurr_CaseData({
          data: CaseData,
          comments: CaseComentsData,
          files: CaseFilesData,
        });
        setLoading(false);
      }
      if (!response?.payload?.isValidate) {
        setCurr_CaseData({
          data: null,
          comments: [],
          files: [],
        });
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    FetchCaseGetList();
  }, [sort, filters]);

  const handleshowContactPopup = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");

      handleOverlay(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowContact(!showContact);
  };

  const handleOverlay = (e) => {
    let element = document.getElementById(e?.currentTarget?.id);
    if (element) {
      if (element.classList.contains("overlay-isopen")) {
        element.classList.remove("overlay-isopen");
      } else {
        element.classList.add("overlay-isopen");
      }
    }
  };

  const handleshowSchedularPopup = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      handleOverlay(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowSchedularPopup(!showSchedularPopup);
  };

  async function getProjectTermList() {
    dispatch(ProjectTermGetList({}))?.then((response) => {
      if (response?.payload?.isValidate) {
        if (response?.payload?.data?.data?.length > 0) {
          let priorityStatus = response?.payload?.data?.data.filter(
            (f) => f.category === "Case Status Term"
          );
          setProjectTermList({
            CaseType: priorityStatus,
          });
        }
      }
      if (!response?.payload?.isValidate) {
        setProjectTermList({
          CaseType: [],
        });
        setLoading(false);
      }
    });
  }
  const [sortStatePayload, setSortStatePayload] = React.useState({
    field: null,
    direction: null,
  });

  useEffect(() => {
    getProjectTermList();
  }, []);

  const handleOutsideClick = (event) => {
    if (
      overlayCont_Ref.current &&
      !overlayCont_Ref.current.contains(event.target) &&
      !contactRef.current.contains(event.target)
    ) {
      handleshowContactPopup(event); // Close the overlay
    }
  };

  useEffect(() => {
    if (showContact) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [showContact]);

  const HandleCaseStatusUpdate = async (status_Term) => {
    let body = {
      caseid: caseId,
      casestatus_term: status_Term,
    };
    //
    try {
      dispatch(CaseUpdateStatus(body)).then(async (response) => {
        if (response?.payload?.isValidate) {
          // setCaseStatus(status_Term);
          FetchCaseGetList();
        }
        if (!response?.payload?.isValidate) {
          setCaseStatus(caseStatus);
        }
      });
    } catch (error) {}
  };

  useEffect(() => {
    FetchCaseGetList();
  }, [sortStatePayload, filters]);
  return (
    <>
      {caseId === null ? (
        <div className="setting-table-main">
          <div className="table-wrapper-main">
            <div className="">
              <Row style={{ width: "-webkit-fill-available" }}>
                {/* <Col xs lg="10" className="text-start">
                  <h3>Cases List</h3>
                </Col> */}
                {/* Case Filters */}
                <Col lg="12">
                  <div className="casedata-filter-main">
                    <div
                      className="filtering-main"
                      id="log-filter-five"
                      onClick={(e) => {
                        e.preventDefault();
                        handleOverlay(e);
                        setShowSchedularPopup(!showSchedularPopup);
                        handleshowSchedularPopup();
                      }}
                      ref={targetFilter}
                    >
                      <img src={filtericon} alt="filtericon" />
                      <span>Sort & Filter</span>
                    </div>
                    {showSchedularPopup && (
                      <Overlay
                        target={targetFilter.current}
                        show={handleshowSchedularPopup}
                        placement="bottom"
                      >
                        <Tooltip id="overlay-example">
                          <CaseFilterPopup
                            sortStatePayload={sortStatePayload}
                            setSortStatePayload={setSortStatePayload}
                            filters={filters}
                            setFilters={setFilters}
                            handleshowPopup={handleshowSchedularPopup}
                            showStatusFilter={false}
                          />
                        </Tooltip>
                      </Overlay>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
            <Table responsive>
              <thead>
                <tr>
                  <th className="width135 sticky-workflow">Case ID</th>
                  <th className="width200">Subject</th>
                  <th className="text-center width100 ">Severity</th>
                  <th className="text-center width100">Related To</th>
                  <th className="text-center width100">Case Type</th>
                  <th className="text-center width135">Created By</th>
                  <th className="text-center width135">Opened By</th>
                  <th className="text-center width135">Resolved By</th>
                  <th className="text-center width135">Created on</th>
                  <th className="text-center width150">Last Updated on</th>

                  <th className=" width135">Status</th>
                  <th className="text-end sticky-actions">Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <Loader type={LoaderType.TableRow} count={5} nooftd={9} />
                ) : (
                  <>
                    {casesList?.length > 0 ? (
                      casesList?.map((item) => {
                        return (
                          <tr>
                            <td className="theme-color-text fw600 sticky-workflow">
                              {item?.caseno}
                            </td>
                            <td title={item?.title}>
                              {commonservices.truncateText(item?.title, 20)}
                            </td>
                            <td className="text-center">
                              <span
                                className={`${
                                  item?.priority_term.toLowerCase() === "high"
                                    ? "redbage"
                                    : item?.priority_term.toLowerCase() ===
                                      "medium"
                                    ? "yellowbage"
                                    : "bluebage"
                                } commonbtncase`}
                              >
                                {item?.priority_term}
                              </span>
                            </td>{" "}
                            <td className="text-center">
                              {item?.associationtype_term}
                            </td>
                            <td className="text-center">
                              {item?.casetype_term}
                            </td>
                            <td
                              className="text-center"
                              title={item?.createdname}
                            >
                              {commonservices.truncateText(
                                item?.createdname,
                                10
                              )}
                            </td>
                            <td className="text-center" title={item?.openedby}>
                              {commonservices.truncateText(item?.openedby, 10)}
                            </td>
                            <td className="text-center" title={item?.resolveby}>
                              {commonservices.truncateText(item?.resolveby, 10)}
                            </td>
                            <td className="text-center">
                              {commonservices?.getDateInFormat(item?.createdon)}
                            </td>
                            <td className="text-center">
                              {commonservices?.getDateInFormat(item?.updatelog)}
                            </td>
                            <td>
                              {commonservices.getStatus(item?.casestatus_term)}
                            </td>
                            <td className="sticky-actions">
                              <div className="all-actions ">
                                <span
                                  onClick={() => {
                                    setShowCaseDetails(true);
                                    FetchAll_CaseDetailById(item?.caseid);
                                    setCaseId(item?.caseid);
                                    setDataHistoryId(item?.caseid);
                                  }}
                                >
                                  <img src={viewaction} alt="viewaction" />
                                </span>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <></>
                      // <tr>
                      //   <td colSpan={100}>
                      //     <Nodata />
                      //   </td>
                      // </tr>
                    )}
                  </>
                )}
              </tbody>
            </Table>
            {casesList?.length === 0 && !loading && (
              <>
                <Table>
                  <tbody>
                    <tr>
                      <td>
                        {casesList?.length === 0 && !loading && <Nodata />}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </>
            )}
          </div>
        </div>
      ) : (
        <>
          {!loading ? (
            <>
              <div className="casedetail-profile-main">
                <div className="profile-common-title">
                  <h3>Case Detail</h3>
                </div>
                <div className="profile-common">
                  <div className="casedetail-profile">
                    <div className="casedetail-profile-title">
                      <div className="casedetail-profile-title-left ">
                        <h3>{curr_CaseData?.data?.caseno}</h3>
                        <p>Workflow Issue</p>
                      </div>
                      <div className="casedetail-profile-title-right d-flex align-items-center gap-2">
                        <Row className="align-items-center">
                          {/* Status Badges */}
                          <Col xs="auto p-0 me-2">
                            <span
                              className={`${
                                curr_CaseData?.data?.priority_term?.toLowerCase() ===
                                "high"
                                  ? "casebtnsetred"
                                  : curr_CaseData?.data?.priority_term?.toLowerCase() ===
                                    "medium"
                                  ? "casebtnsetyellow"
                                  : "casebtnsetblue"
                              } casebtnsetred`}
                            >
                              {curr_CaseData?.data?.priority_term}
                            </span>
                          </Col>
                          <Col xs="auto p-0 me-2">
                            <div className="casedetail-drop">
                              <Dropdown>
                                <Dropdown.Toggle
                                  variant="light"
                                  className={`${
                                    caseStatus?.toLowerCase() === "open"
                                      ? "case-detail-status-green"
                                      : caseStatus?.toLowerCase() === "closed"
                                      ? "case-detail-status-red"
                                      : caseStatus?.toLowerCase() ===
                                        "in progress"
                                      ? "case-detail-status-blue"
                                      : "case-detail-status-yellow"
                                  } casedetail-drop`}
                                >
                                  {caseStatus
                                    ? caseStatus
                                    : curr_CaseData?.data?.casestatus_term}
                                  {/* SVG Arrow */}

                                  <img
                                    src={dropdownafter}
                                    alt="dropdownafter"
                                  />
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="casedetail-dropdown">
                                  {ProjectTermList.CaseType.filter(
                                    (a) =>
                                      a?.term?.toLowerCase() === "closed" ||
                                      a?.term?.toLowerCase() === "re-open"
                                  )?.map((itm, idx) => (
                                    <>
                                      <Dropdown.Item
                                        // disabled
                                        onClick={(e) => {
                                          setCaseStatus(itm.term);
                                          HandleCaseStatusUpdate(itm.term);
                                        }}
                                      >
                                        <h6>
                                          <span
                                            className={`${
                                              itm.term?.toLowerCase() === "open"
                                                ? "case-detail-status-green"
                                                : itm.term?.toLowerCase() ===
                                                  "closed"
                                                ? "case-detail-status-red"
                                                : itm.term?.toLowerCase() ===
                                                  "in progress"
                                                ? "case-detail-status-blue"
                                                : "case-detail-status-yellow"
                                            }`}
                                          ></span>
                                          {itm.term}
                                        </h6>
                                      </Dropdown.Item>
                                    </>
                                  ))}
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </Col>
                          {/* Profile Section */}
                          <Col>
                            <div
                              className={
                                "d-flex align-items-center justify-content-end p-0 me-2 cursor-pointer  overlay-isopen"
                              }
                              onClick={(e) => {
                                if (
                                  curr_CaseData?.data?.assignsubscriberid ==
                                  Userdata?.subscriberid
                                ) {
                                  // e.preventDefault();
                                  handleOverlay(e);
                                  setShowContact(!showContact);
                                  handleshowContactPopup();
                                }
                              }}
                              ref={contactRef}
                            >
                              <Image
                                src={
                                  curr_CaseData?.data?.profilepic
                                    ? curr_CaseData?.data?.profilepic
                                    : profilepageman
                                }
                                roundedCircle
                                alt="Esther Howard"
                                width={30}
                                height={30}
                                className="me-2"
                                onError={({ currentTarget }) => {
                                  currentTarget.onerror = null;
                                  currentTarget.src = profilepageman;
                                }}
                              />
                              <div className="casedetailprofile">
                                <h6 className="mb-0 fw-bold">
                                  {curr_CaseData?.data?.resolveby}
                                </h6>
                                <p className="text-muted mb-0 small">
                                  {curr_CaseData?.data?.usertype_term}
                                </p>
                              </div>
                              {/* {curr_CaseData?.data?.assignsubscriberid ==
                                Userdata?.subscriberid && (
                                <div
                                  className={`casedetail-profile-drop mt-2 `}
                                >
                                  <Dropdown align="end">
                                    <Dropdown.Toggle
                                      variant="link"
                                      className="p-0 text-dark"
                                      style={{ textDecoration: "none" }}
                                    ></Dropdown.Toggle>
                                  </Dropdown>
                                </div>
                              )} */}
                            </div>
                          </Col>
                          {/* {showContact ? (
                            <>
                              <Overlay
                                ref={overlayCont_Ref}
                                target={contactRef.current}
                                show={showContact}
                                placement="bottom"
                              >
                                {(props) => (
                                  <Tooltip id="overlay-example" {...props}>
                                    <SupportCaseContactModel
                                      caseId={caseId}
                                      getCaseDetails={FetchAll_CaseDetailById}
                                      handleshowPopup={handleshowContactPopup}
                                      redirect={() => {
                                        navigate("/management-listing", {
                                          state: "cases",
                                        });
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </Overlay>
                            </>
                          ) : (
                            ""
                          )} */}
                        </Row>
                      </div>
                    </div>
                    <Row>
                      <Col sm={3}>
                        <div className="casedetail-set">
                          <h4>Related To</h4>
                          <p>{curr_CaseData?.data?.casetype_term} </p>
                        </div>
                      </Col>
                      <Col sm={3}>
                        <div className="casedetail-set">
                          <h4>Created By</h4>
                          <p>{curr_CaseData?.data?.displayname}</p>
                        </div>
                      </Col>
                      <Col sm={3}>
                        <div className="casedetail-set">
                          <h4>Opened By</h4>
                          <p>{curr_CaseData?.data?.openedby}</p>
                        </div>
                      </Col>
                      <Col sm={3}>
                        <div className="casedetail-set border-end-0">
                          <h4>Resolved By</h4>
                          <p>{curr_CaseData?.data?.resolveby}</p>
                        </div>
                      </Col>
                      <Col sm={6}>
                        <div className="casedetail-set">
                          <h4>Related Name</h4>
                          <p>{curr_CaseData?.data?.relatedname}</p>
                        </div>
                      </Col>
                      <Col sm={3}>
                        <div className="casedetail-set">
                          <h4>Created On</h4>
                          <p>
                            {commonservices.convertDateToLocal(
                              curr_CaseData?.data?.createdon
                            )}
                          </p>
                        </div>
                      </Col>
                      <Col sm={3}>
                        <div className="casedetail-set border-end-0">
                          <h4>Last Updated On</h4>
                          <p>
                            {commonservices.convertDateToLocal(
                              curr_CaseData?.data?.updatelog
                            )}
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <div className="case-description">
                      <div className="description-title-main">
                        <div className="d-flex gap-2 align-items-center">
                          <h4>Description</h4>
                          <Form.Group
                            className="form-group mb16 pt-0 pb-0 width100"
                            style={{ height: "28px" }}
                          >
                            <div className="position-relative">
                              <Form.Select className="common-select">
                                <option value={""}>English</option>
                              </Form.Select>
                            </div>
                          </Form.Group>
                        </div>
                        <p className="ckediter-datacontent">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: curr_CaseData?.data?.detail,
                            }}
                          />
                        </p>
                      </div>
                    </div>
                    <div className="caseiamge-tab">
                      {curr_CaseData?.files.length !== 0 && (
                        <Tab.Container
                          id="left-tabs-example"
                          defaultActiveKey={selectedFile.fileNo}
                        >
                          <Row>
                            <Col sm={1} className="file-list-height">
                              <Nav variant="pills" className="flex-column">
                                {curr_CaseData?.files.length !== 0 &&
                                  curr_CaseData?.files.map((itm, index) => (
                                    <Nav>
                                      <Nav.Item
                                        key={index}
                                        onClick={(e) => {
                                          setSelectedFile({
                                            fileNo: index,
                                            path: itm?.path,
                                            data: itm,
                                          });
                                        }}
                                      >
                                        <Nav.Link eventKey={index}>
                                          {itm?.contenttype?.includes("pdf") ? (
                                            <img
                                              width={"38px"}
                                              height={"38px"}
                                              src={SVGRef}
                                              alt={"File"}
                                              title={itm.title}
                                              onError={({ currentTarget }) => {
                                                currentTarget.onerror = null;
                                                currentTarget.src = SVGRef;
                                              }}
                                            />
                                          ) : (
                                            <img
                                              width={"38px"}
                                              height={"38px"}
                                              src={itm?.path || noDataFound}
                                              alt={"File"}
                                              title={itm.title}
                                              onError={({ currentTarget }) => {
                                                currentTarget.onerror = null;
                                                currentTarget.src = noDataFound;
                                              }}
                                            />
                                          )}
                                        </Nav.Link>
                                      </Nav.Item>
                                    </Nav>
                                  ))}
                              </Nav>
                            </Col>
                            <Col sm={11}>
                              <Tab.Content>
                                <Tab.Pane eventKey={selectedFile.fileNo}>
                                  {selectedFile?.data?.contenttype?.includes(
                                    "pdf"
                                  ) ? (
                                    <div
                                      className="cursor-pointer"
                                      onClick={() => {
                                        window.open(
                                          selectedFile.path,
                                          "_blank"
                                        );
                                      }}
                                    >
                                      {" "}
                                      <svg
                                        width="167"
                                        height="142"
                                        viewBox="0 0 167 142"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M68.6082 5.12783C70.0296 5.12783 71.1568 3.99378 71.1568 2.56391C71.1568 1.13404 70.0296 0 68.6082 0C67.1869 0 66.0596 1.13404 66.0596 2.56391C66.0596 3.99378 67.1869 5.12783 68.6082 5.12783Z"
                                          fill="#CFCFCF"
                                        />
                                        <path
                                          d="M8.6543 129.045V140.336"
                                          stroke="#BABABA"
                                          stroke-width="3.07256"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M3.07324 134.713H14.297"
                                          stroke="#BABABA"
                                          stroke-width="3.07256"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M116.608 136.128C118.03 136.128 119.157 134.994 119.157 133.564C119.157 132.134 118.03 131 116.608 131C115.187 131 114.06 132.134 114.06 133.564C114.06 134.994 115.187 136.128 116.608 136.128Z"
                                          fill="#CFCFCF"
                                        />
                                        <path
                                          d="M159.209 9.21875V20.5098"
                                          stroke="#BABABA"
                                          stroke-width="3.07256"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M153.628 14.8867H164.852"
                                          stroke="#BABABA"
                                          stroke-width="3.07256"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <g clip-path="url(#clip0_11253_30968)">
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M42.277 101.734L27.7171 61.248C27.508 60.6584 27.8184 60.0053 28.408 59.7899C47.5508 52.905 69.1214 46.5016 87.5606 38.6339C88.3845 38.1141 89.0311 38.6276 89.3861 39.6102L112.262 98.5767L118.474 115.853C118.684 116.442 118.379 117.102 117.79 117.311L74.0149 133.053L56.9511 139.19C56.3615 139.405 55.7086 139.095 55.4932 138.505L42.277 101.734Z"
                                            fill="white"
                                          />
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M54.4162 88.3015L47.1458 45.9008C47.038 45.2795 47.4565 44.6899 48.0714 44.5821L98.1406 35.998L109.607 34.1087C110.235 33.8361 111.255 34.153 111.496 35.5542L123.882 97.4056L126.982 115.499C127.089 116.115 126.671 116.71 126.056 116.818L80.2082 124.68L62.3332 127.748C61.7183 127.85 61.1225 127.431 61.0147 126.816L54.4162 88.3015Z"
                                            fill="white"
                                          />
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M68.4436 75.798V116.563C68.4436 117.216 68.9761 117.755 69.629 117.755H88.5499H116.561H120.586H137.079C137.732 117.755 138.264 117.216 138.264 116.563V97.4105V44.5047V43.9532H126.221C125.061 43.9532 122.652 44.118 122.652 41.4871L122.627 29.7266H69.6288C68.9759 29.7266 68.4434 30.2591 68.4434 30.9122V41.0876V45.3924V75.798H68.4436Z"
                                            fill="white"
                                          />
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M48.3495 52.9316C41.5671 55.2141 34.8481 57.4773 28.408 59.7913C27.8184 60.0069 27.508 60.6598 27.7171 61.2494L42.277 101.736L55.4932 138.506C55.7088 139.096 56.3617 139.407 56.9511 139.191L74.0149 133.054L112.897 119.075L48.3495 52.9316Z"
                                            fill="white"
                                          />
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M68.4438 41.0879L48.0714 44.581C47.4565 44.6888 47.038 45.2784 47.1458 45.8997L48.3503 52.9305L54.4164 88.3004L61.0149 126.815C61.1227 127.43 61.7185 127.848 62.3334 127.747L80.2085 124.678L112.897 119.074L120.586 117.755H116.561L68.4438 41.0879Z"
                                            fill="white"
                                          />
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M138.264 97.4105V44.5047V43.9532V43.7693C138.264 43.4269 138.118 43.3699 137.592 42.8563L124.592 30.4557C123.977 29.8724 123.876 29.7266 123.514 29.7266H122.627H69.6288C68.9759 29.7266 68.4434 30.2591 68.4434 30.9122V116.563C68.4434 117.216 68.9759 117.755 69.6288 117.755H137.079C137.732 117.755 138.264 117.216 138.264 116.563V97.4105Z"
                                            fill="white"
                                          />
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M68.4434 41.0879L63.6704 41.9058V120.944C63.6704 121.604 64.2029 122.136 64.8558 122.136H83.7767H95.0343L112.897 119.074L120.585 117.755H116.56H111.61H88.5497H69.6288C68.9759 117.755 68.4434 117.217 68.4434 116.564C68.4434 91.4068 68.4434 66.2441 68.4434 41.0879Z"
                                            fill="#D2D2D2"
                                          />
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M54.4163 88.3015L48.3501 52.9316C46.7084 53.4832 45.073 54.0347 43.4438 54.5863L44.1983 58.9799L50.2644 94.3498L56.8694 132.864C56.9707 133.479 57.5665 133.897 58.1814 133.796L76.0564 130.728L84.5377 129.276L110.083 120.083L109.778 119.608L95.0346 122.137L80.2085 124.68L62.3334 127.748C61.7186 127.85 61.1228 127.431 61.0149 126.816L54.4163 88.3015Z"
                                            fill="#D2D2D2"
                                          />
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M138.264 97.4105V44.5047V43.9532C138.264 43.3128 138.054 43.3066 137.592 42.8563L124.591 30.4557C123.976 29.8724 123.875 29.7266 123.513 29.7266H122.626H109.435C125.554 51.3073 126.473 90.2084 114.512 114.49C113.961 115.618 113.384 116.703 112.782 117.755H116.56H120.585H137.078C137.731 117.755 138.264 117.216 138.264 116.563V97.4105Z"
                                            fill="#D2D2D2"
                                          />
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M122.652 41.4871C122.652 44.118 125.06 43.9532 126.22 43.9532H138.264V43.7693C138.264 43.4269 138.118 43.3699 137.592 42.8563L124.592 30.4557C123.977 29.8724 123.875 29.7266 123.514 29.7266H122.626L122.652 41.4871Z"
                                            fill="white"
                                          />
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M137.592 42.8563L124.592 30.4557C123.977 29.8724 123.875 29.7266 123.514 29.7266H122.626L122.652 41.4869C122.652 44.1178 125.06 43.9529 126.22 43.9529H138.264V43.7691C138.264 43.4269 138.118 43.3699 137.592 42.8563Z"
                                            fill="#A6A6A6"
                                          />
                                          <path
                                            d="M127.552 55.654H79.8283C78.9065 55.654 78.1592 54.9065 78.1592 53.9842C78.1592 53.0619 78.9065 52.3145 79.8283 52.3145H127.552C128.474 52.3145 129.221 53.0619 129.221 53.9842C129.221 54.9065 128.474 55.654 127.552 55.654Z"
                                            fill="#D2D2D2"
                                          />
                                          <path
                                            d="M127.552 67.5153H79.8283C78.9065 67.5153 78.1592 66.7678 78.1592 65.8455C78.1592 64.9233 78.9065 64.1758 79.8283 64.1758H127.552C128.474 64.1758 129.221 64.9233 129.221 65.8455C129.221 66.7678 128.474 67.5153 127.552 67.5153Z"
                                            fill="#D2D2D2"
                                          />
                                          <path
                                            d="M127.552 79.3786H79.8283C78.9065 79.3786 78.1592 78.6311 78.1592 77.7088C78.1592 76.7866 78.9065 76.0391 79.8283 76.0391H127.552C128.474 76.0391 129.221 76.7866 129.221 77.7088C129.221 78.6311 128.474 79.3786 127.552 79.3786Z"
                                            fill="#D2D2D2"
                                          />
                                          <path
                                            d="M127.552 91.2399H79.8283C78.9065 91.2399 78.1592 90.4924 78.1592 89.5702C78.1592 88.6479 78.9065 87.9004 79.8283 87.9004H127.552C128.474 87.9004 129.221 88.6479 129.221 89.5702C129.221 90.4924 128.474 91.2399 127.552 91.2399Z"
                                            fill="#D2D2D2"
                                          />
                                          <path
                                            d="M127.552 103.099H79.8283C78.9065 103.099 78.1592 102.352 78.1592 101.43C78.1592 100.507 78.9065 99.7598 79.8283 99.7598H127.552C128.474 99.7598 129.221 100.507 129.221 101.43C129.221 102.352 128.474 103.099 127.552 103.099Z"
                                            fill="#D2D2D2"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_11253_30968">
                                            <rect
                                              width="110.612"
                                              height="110.612"
                                              fill="white"
                                              transform="translate(27.6528 29.1895)"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </div>
                                  ) : (
                                    <img
                                      src={selectedFile.path}
                                      title="Main File"
                                      alt="File"
                                      onError={({ currentTarget }) => {
                                        currentTarget.onerror = null;
                                        currentTarget.src = dummyBanner;
                                      }}
                                    />
                                  )}
                                </Tab.Pane>
                              </Tab.Content>
                            </Col>
                          </Row>
                        </Tab.Container>
                      )}
                    </div>
                  </div>
                </div>
                {curr_CaseData?.comments?.length !== 0 && (
                  <div className="profile-common-title">
                    <h3>Comments</h3>
                  </div>
                )}

                <div className="file-list-height mb-2">
                  {curr_CaseData?.comments?.length !== 0 &&
                    curr_CaseData?.comments?.map((itm, index) => (
                      <>
                        <div className="profile-common">
                          <div className="case-comments-page">
                            <div className="comments-page-profile">
                              <div className="d-flex gap-2 align-items-center">
                                <img
                                  src={
                                    itm?.profilepic
                                      ? itm?.profilepic
                                      : profilepageman
                                  }
                                  alt="userimage"
                                  onError={({ currentTarget }) => {
                                    currentTarget.onerror = null;
                                    currentTarget.src = profilepageman;
                                  }}
                                />
                                <div className="detailcomments-case ">
                                  <h4>{itm?.displayname}</h4>
                                  <span>
                                    {commonservices.convertDateToLocal(
                                      itm?.activityon
                                    )}
                                  </span>
                                </div>
                              </div>
                              <p>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: itm?.comment,
                                  }}
                                />
                              </p>
                            </div>
                          </div>
                        </div>
                      </>
                    ))}
                </div>
              </div>
            </>
          ) : (
            <>
              <Loader type={LoaderType.SupportDetail} />
            </>
          )}
        </>
      )}
    </>
  );
};

export default CaseHistoryManagementModel;
